import React, { useEffect, useState } from "react";
import { backend, API_URL } from "../../config";
import {
  Grid,
  Typography,
  IconButton,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import InfiniteTable from "../../components/InfiniteTable/InfiniteTable";
import "./Order.css";
import { useSelector } from "react-redux";

import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

import EditIcon from "@mui/icons-material/Edit";

const Order = (props) => {
  const {
    columns,
    customer = {},
    data,
    storeAddons = false,
    editable = false,
    order = {},
    setOrder = null,
  } = props;

  const currentUserStore = useSelector((state) => state.current_user);

  const cDate = new Date();
  let eDate = new Date();
  eDate.setDate(eDate.getDate() + 1);

  const cDateString = new Date(
    cDate.getTime() - cDate.getTimezoneOffset() * 60000
  )
    .toISOString()
    .split("T")[0];

  const eDateString = new Date(
    eDate.getTime() - eDate.getTimezoneOffset() * 60000
  )
    .toISOString()
    .split("T")[0];

  const [editing, setEditing] = useState(false);
  const [note, setNote] = useState("");

  const handleChange = async (e) => {
    const { name, value } = e.target;

    let orderObj = {};

    if (name === "delivery_date") {
      value.setHours(0, 0, 0, 0);
      orderObj = { ...orderObj, delivery_date: value.toISOString() };
    }

    if (name === "placed_date") {
      orderObj = { ...orderObj, placed_date: value.toISOString() };
    }

    if (Object.keys(orderObj).length && order.hasOwnProperty("id")) {
      await backend
        .patch(`${API_URL}orders/${order.id}`, orderObj)
        .then(({ data }) => {
          if (setOrder !== null) {
            setOrder({ ...order, ...data, customer: order.customer });
          }
          setEditing(false);
        });
    }
  };

  const handleCancel = () => {
    setNote(order.note);
    setEditing(false);
  };

  const handleSave = async () => {
    const orderObj = { note: note };

    await backend
      .patch(`${API_URL}orders/${order.id}`, orderObj)
      .then(({ data }) => {
        if (setOrder !== null) {
          setOrder({ ...order, ...data, customer: order.customer });
        }
        setEditing(false);
      });
  };

  useEffect(() => {
    if (order?.note) {
      setNote(order.note);
    }
  }, [order]);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle1">
            <strong>Customer: </strong>
            {customer.hasOwnProperty("username")
              ? customer.username
              : customer.hasOwnProperty("name")
              ? customer.name
              : "Anonymous"}
          </Typography>
          {order.hasOwnProperty("id") ? (
            <Typography variant="subtitle1">
              <strong>Status: </strong>
              {order.hasOwnProperty("status")
                ? order.status_label
                : "Submitted"}
            </Typography>
          ) : (
            <></>
          )}
          <Typography variant="subtitle1">
            <strong>Placed: </strong>
            {!editing ? (
              <>
                {order.hasOwnProperty("created_date")
                  ? order.created_date.split("T")[0]
                  : cDateString}
                {editable && currentUserStore && currentUserStore.is_staff ? (
                  <IconButton
                    variant="contained"
                    onClick={() => setEditing(true)}
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                  >
                    <EditIcon color="inherit" />
                  </IconButton>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    value={order.created_date}
                    renderInput={(props) => (
                      <TextField {...props} variant="standard" />
                    )}
                    onChange={(date) =>
                      handleChange({
                        target: {
                          name: "placed_date",
                          value: date,
                        },
                      })
                    }
                  />
                </LocalizationProvider>
              </>
            )}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Estimated Delivery: </strong>
            {!editing ? (
              <>
                {order.hasOwnProperty("delivery_date")
                  ? order.delivery_date.split("T")[0]
                  : eDateString}
                {editable && currentUserStore && currentUserStore.is_staff ? (
                  <IconButton
                    variant="contained"
                    onClick={() => setEditing(true)}
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                  >
                    <EditIcon color="inherit" />
                  </IconButton>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    value={order.delivery_date}
                    renderInput={(props) => (
                      <TextField {...props} variant="standard" />
                    )}
                    onChange={(date) =>
                      handleChange({
                        target: {
                          name: "delivery_date",
                          value: date,
                        },
                      })
                    }
                  />
                </LocalizationProvider>
              </>
            )}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Invoiced: </strong>
            {order.hasOwnProperty("invoiced") ? "" + order.invoiced : "false"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          {editable && currentUserStore && currentUserStore.is_staff ? (
            <Typography variant="subtitle1">
              <strong>Note: </strong>
              {!editing ? (
                <>
                  {order.note}
                  <IconButton
                    variant="contained"
                    onClick={() => setEditing(true)}
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                  >
                    <EditIcon color="inherit" />
                  </IconButton>
                </>
              ) : (
                <>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    multiline
                    minRows={2}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  />
                  <Stack
                    direction="row"
                    spacing={1}
                    style={{ marginTop: 8 }}
                    justifyContent="right"
                  >
                    <Button
                      variant="contained"
                      size="small"
                      color="error"
                      onClick={() => handleCancel()}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="success"
                      onClick={() => handleSave()}
                      disabled={order?.note === note}
                    >
                      Save
                    </Button>
                  </Stack>
                </>
              )}
            </Typography>
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={12}>
          <InfiniteTable
            {...props}
            columns={columns}
            data={data}
            dataMapByColumn="id"
            deletable={false}
            editable={true}
            filterable={true}
            label="Order Items"
            fetchingModal={null}
            storeAddons={storeAddons}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Order;
